<template>
  <b-card v-if="work">
    <b-card-header>Att göra</b-card-header>
    <b-card-body>
      <b-row>
        <b-button v-if="IsChanged()" @click="SaveChanges()">Spara</b-button>
        <b-button v-if="IsChanged()" @click="CancelChanges()">Avbryt</b-button>
        <b-button v-if="!IsChanged() && work.Id > 0" @click="Delete()"
          >Ta bort</b-button
        >
      </b-row>
      <b-row>
        <b-col
          ><label>Namn:</label><br />
          <b-input type="text" v-model="work.Name" maxlength="50"></b-input>
        </b-col>
        <b-col
          ><label>Area:</label><br />
          <b-input type="text" v-model="work.Area" maxlength="50"></b-input>
        </b-col>
        <b-col cols=1>
          <label>Prio:</label>
          <b-select v-model="work.Prio" :options="GetPrios()"></b-select>
        </b-col>
        <b-col cols=1>
          <label>Status:</label>
          <b-select v-model="work.StatusId" :options="GetStatusIds()"></b-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Beskrivning:</label><br />
          <b-textarea v-model="work.Comment" rows="6"></b-textarea>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Ansvarig:</label><br />
          <b-input v-model="work.Responsible" maxlength="50"></b-input>
        </b-col>
        <b-col>
          <label>Färdighet:</label><br />
          <b-row>
            <b-col cols="10"
              ><b-input type="range" v-model="work.Status"></b-input>
            </b-col>
            <b-col
              ><b-badge>{{ work.Status }}%</b-badge></b-col
            >
          </b-row>
        </b-col>
      </b-row>
      <b-row>
          <b-col>
              <label>Registrerad:</label><br />{{work.RegDate| formatDateTime}} {{work.RegByUserName}}
          </b-col>
          <b-col>
              <label>Ändrad:</label><br />{{work.ChangedDate| formatDateTime}} 
          </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>
<script>
import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "todoedit",
  props: { id: Number },
  data() {
    return {
      work: null,
      origJson: null,
    };
  },
  created() {
    this.GetData();
  },
  watch: {
    id: function () {
      this.GetData();
    },
  },
  methods: {
    GetData() {
      if (this.id > 0) {
        api.get("/api/todotask/" + this.id).then((res) => {
          this.work = res.data;
          this.origJson = JSON.stringify(this.work);
        });
      } else {
        this.work = { Status: 0 };
        this.origJson = JSON.stringify(this.work);
      }
    },
    SaveChanges() {
      if (this.work) {
        api.post("/api/todotask", this.work).then((res) => {
          this.work = res.data;
          this.origJson = JSON.stringify(this.work);
        });
      }
    },
    CancelChanges() {
      this.GetData();
    },
    Delete() {
      if (this.work)
        if (confirm("Ta bort denna aktivitet?")) {
          api.delete("/api/todotask/" + this.id).then((res) => {
            this.work = null;
            this.origJson = null;
            alert("Borttagen!");
          });
        }
    },
    IsChanged() {
      if (this.work) {
        return JSON.stringify(this.work) != this.origJson;
      }
      return false;
    },
    GetPrios() {
      return [
        { value: 1, text: "1-Akut" },
        { value: 2, text: "2-Medel" },
        { value: 3, text: "3-Låg" },
      ];
    },
    GetStatusIds() {
        return [
        { value: 0, text: "Ny" },
        { value: 100, text: "Påbörjad" },
        { value: 200, text: "Klar utv." },
        { value: 300, text: "Release" },
      ];
    }
  },
};
</script>